import { openDB } from 'idb';
import { supabase } from '@/integrations/supabase/client';

type TrainingOutboxItem = {
  id?: number;
  type: 'submit_attempt';
  payload: Record<string, unknown>;
  created_at: string;
};

const DB_NAME = 'training_outbox';
const STORE_NAME = 'outbox';

const dbPromise = openDB(DB_NAME, 1, {
  upgrade(db) {
    if (!db.objectStoreNames.contains(STORE_NAME)) {
      db.createObjectStore(STORE_NAME, { keyPath: 'id', autoIncrement: true });
    }
  },
});

export const enqueueTrainingSubmission = async (payload: Record<string, unknown>) => {
  const db = await dbPromise;
  const item: TrainingOutboxItem = {
    type: 'submit_attempt',
    payload,
    created_at: new Date().toISOString(),
  };
  await db.add(STORE_NAME, item);
};

export const flushTrainingOutbox = async () => {
  if (!navigator.onLine) return;
  const db = await dbPromise;
  const tx = db.transaction(STORE_NAME, 'readwrite');
  const store = tx.objectStore(STORE_NAME);
  const items = await store.getAll();

  for (const item of items as TrainingOutboxItem[]) {
    if (item.type === 'submit_attempt') {
      const { error } = await supabase.functions.invoke('submit-assessment-attempt', {
        body: item.payload,
      });
      if (!error && item.id !== undefined) {
        await store.delete(item.id);
      }
    }
  }

  await tx.done;
};
